import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Booking } from './pages/Booking';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <div className="min-h-screen flex flex-col bg-white font-sans text-navy" data-id="element-3">
          <Navbar data-id="element-4" />
          <main className="flex-grow" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
              <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
              <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
              <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
              <Route path="/booking" element={<Booking data-id="element-16" />} data-id="element-15" />
            </Routes>
          </main>
          <Footer data-id="element-17" />
          <FloatingActions data-id="element-18" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}